declare const jhsapp: any;

/**
 * 获取用户token
 * @returns {Promise<string | null>} 返回token字符串，如果没有token则返回null
 */
export const getToken = async (): Promise<string | null> => {
  try {
    // 测试环境返回一个测试token
    // if (__ENV__ === 'dev') {
    //   return 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbnYiOiJ0ZXN0aW5nIiwiY3JlYXRlZF9hdCI6eyJkYXRlIjoiMjAyNS0wNC0yNCAxOTowOTo0My4wMDAwMDAiLCJ0aW1lem9uZV90eXBlIjozLCJ0aW1lem9uZSI6IkFzaWEvVG9reW8ifSwic3ViIjo0MTQ0ODMyLCJpc3MiOiJodHRwOi8vZ2Fvc2lqaWUuYXBpLWRldi50Y2djYXJkLmpwL2FwaS9tYXJrZXQvYXV0aC9hdXRoMC1zbnMtbG9naW4iLCJpYXQiOjE3NjQ1Njc0OTQsImV4cCI6MTc2OTc1MTQ5NCwibmJmIjoxNzY0NTY3NDk0LCJqdGkiOiI1U2lqd05kYjlybjg3R1VOIn0.0tVHaK2ae8ZbfTqeYez32LYmeILSgzvOcMLPR84GQNo';
    // }
    if (typeof window !== 'undefined' && window.jhsapp && typeof window.jhsapp.getToken === 'function') {
      const token = window.jhsapp.getToken();
      console.log('当前token', token);
      return token;
    }
    // 测试token
    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbnYiOiJ0ZXN0aW5nIiwiY3JlYXRlZF9hdCI6eyJkYXRlIjoiMjAyMy0wNS0xMiAxNzo1NjowNS4wMDAwMDAiLCJ0aW1lem9uZV90eXBlIjozLCJ0aW1lem9uZSI6IkFzaWEvVG9reW8ifSwic3ViIjo5MjkzMTIsImlzcyI6Imh0dHA6Ly9hcGktZGV2LnRjZ2NhcmQuanAvYXBpL21hcmtldC9hdXRoL2xvZ2luIiwiaWF0IjoxNzYwNDQ5MzI5LCJleHAiOjE3NjU2MzMzMjksIm5iZiI6MTc2MDQ0OTMyOSwianRpIjoiZ3k5VUFXaTBUZjVIclpZRyJ9.Tt8tktEE2AxTTQkZ_UVdSiNaeXK6WbRWAxC4zXC94PY'
    // 正式token
    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbnYiOiJwcm9kdWN0aW9uIiwiY3JlYXRlZF9hdCI6eyJkYXRlIjoiMjAyNS0xMC0xNSAwMDo0NjoyMi4wMDAwMDAiLCJ0aW1lem9uZV90eXBlIjozLCJ0aW1lem9uZSI6IkFzaWEvVG9reW8ifSwic3ViIjoxNzg4MDQ4LCJpc3MiOiJodHRwOi8vYXBpLnRjZ2NhcmQuYWkvYXBpL21hcmtldC9hdXRoL2xvZ2luIiwiaWF0IjoxNzYwNDU2NzgzLCJleHAiOjE3NjU2NDA3ODMsIm5iZiI6MTc2MDQ1Njc4MywianRpIjoiNTZMWUxkOXF0dFY0cE5yQiJ9.fgh7meWKacG8dvTZxldzLNOImRmXWPbs8xaAelZ29N4'
    // return token;
    return null;
  } catch (error) {

    // console.error('获取token失败:', error);
    return null;
  }
};

/**
 * 检查用户是否为游客
 * @returns {Promise<boolean>} 返回是否为游客
 */
export const isGuest = async (): Promise<boolean> => {
  // 测试环境直接返回false
  // if (__ENV__ === 'dev') {
  //   return false;
  // }
  try {
    const token = await getToken();
    return !token;
    // 调试时设为false
    // return false;
  } catch (error) {
    console.log('isGuest');
    // console.error('检查用户是否为游客失败:', error);
    return true;
  }
};

/**
 * 检查用户是否为游客，并跳转登录页面
 * @param next 跳转的回调函数
 * @returns {Promise<boolean>} 返回是否为游客
 */
export const checkLoginAndGo = async (next: () => void): Promise<boolean> => {
  const guest = await isGuest();
  // console.log(guest, 'guest');
  if (guest) {
    // 国际环境
    const isInternational = __IS_WW__

    // 根据环境选择跳转官网链接
    const webUrl = isInternational ? 'https://kadoraba.com' : 'https://www.jihuanshe.com';

    if (typeof window !== 'undefined' && window.jhsapp && typeof window.jhsapp.router === 'function') {
      window.jhsapp.router("https://www.jihuanshe.com/app/login");
    } else {
      window.location.href = webUrl;
    }
    return false;
  }
  next();
  return true;
}